import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const InputSkeleton = ({ rows = 5, height = 40 }) => {
  return (
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton
          key={index}
          height={height}
          borderRadius={8}
        />
      ))}
    </div>
  );
};

export default InputSkeleton;
